module.exports = __webpack_public_path__ + "static/media/ajax-Loader.1cce4d29.gif";